import {
    Truck,
    Gift
} from "lucide-react";

import "./ProductBadges.css";


export default function ProductBadges({
    product,
    variation
}) {


    const hasGift = product?.gifts?.length > 0;



    const freeShipping =
        variation?.freeShipping;



    if (!hasGift && !freeShipping) {

        return null;

    }



    return (

        <div className="product-badges">


            {
                freeShipping && (

                    <div className="badge free-shipping">

                        <Truck size={18}/>

                        <span>
                            ارسال رایگان
                        </span>

                    </div>

                )
            }



            {
                hasGift && (

                    <div className="badge gift">

                        <Gift size={18}/>

                        <span>
                            هدیه رایگان
                        </span>

                    </div>

                )
            }


        </div>

    );

}